// extracted by mini-css-extract-plugin
module.exports = {"card":"PricingCard_card__XgFOh","tiers":"PricingCard_tiers__CoSeE","iconContainer":"PricingCard_iconContainer__UiIKZ","logo":"PricingCard_logo__5lyeu"};